export const ProductType = {
  ANCILLARIES_PRODUCT: 'AncillariesProduct',
  ITINERARY_PRODUCT: 'ItineraryProduct',
  ACCOMMODATION_INFO_PRODUCT: 'AccommodationInfoProduct',
};
